import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore';
import { useRoomStore } from '../stores/roomStore';
import { isRoomMember } from '../services/firebase/persistentRooms';
import { RoomLoadingState } from '../components/rooms/room/RoomLoadingState';
import { RoomNotFound } from '../components/rooms/room/RoomNotFound';
import { RoomMeeting } from '../components/rooms/room/RoomMeeting';

/**
 * Persistent room page with lobby and meeting views.
 */
export default function RoomPage() {
  const { roomId } = useParams<{ roomId: string }>();
  const navigate = useNavigate();
  const { user } = useAuthStore();
  const { currentRoom, loadRoom, clearCurrentRoom, isLoading: roomLoading, error } = useRoomStore();

  useEffect(() => {
    if (roomId) {
      loadRoom(roomId);
    }

    return () => {
      clearCurrentRoom();
    };
  }, [roomId, loadRoom, clearCurrentRoom]);

  useEffect(() => {
    if (currentRoom && user && !isRoomMember(currentRoom, user.uid, user.email)) {
      navigate('/');
    }
  }, [currentRoom, user, navigate]);

  if (roomLoading) {
    return <RoomLoadingState />;
  }

  if (error || !currentRoom) {
    return <RoomNotFound onBack={() => navigate('/')} error={error} />;
  }

  if (!user) {
    navigate('/login');
    return null;
  }

  return (
    <RoomMeeting
      room={currentRoom}
      user={user}
      onLeave={() => navigate('/')}
    />
  );
}
